/**
 * PDP Zip Code Integration
 * Syncs PDP zip code input with Cart via localStorage
 * Ticket: MDX-3052
 */

(function () {
  'use strict';

  // Wait for ZipCodeManager to be available
  function initPDPIntegration() {
    if (!window.ZipCodeManager) {
      setTimeout(initPDPIntegration, 100);
      return;
    }

    const zipCodeManager = window.ZipCodeManager;

    /**
     * Find and monitor zip code inputs on PDP
     * Common patterns: postal_code, zip_code, zipcode
     */
    function findZipCodeInputs() {
      const selectors = [
        'input[name="_postal_code"]',
        'input[name="postal_code"]',
        'input[name="zip_code"]',
        'input[name="zipcode"]',
        'input[type="text"][placeholder*="ZIP" i]',
        'input[type="text"][placeholder*="postal" i]',
      ];

      const inputs = [];
      selectors.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((el) => {
          // Skip inputs owned by <pdp-zip-code-editor> — that component already
          // manages its own save flow (Update button, zipCodeManager.set,
          // zipcode:updated dispatch). Letting this script also watch the same
          // input double-saves on every keystroke and updates the display
          // before the user clicks Update.
          if (el.closest('pdp-zip-code-editor')) {
            return;
          }
          if (!inputs.includes(el)) {
            inputs.push(el);
          }
        });
      });

      return inputs;
    }

    /**
     * Auto-populate zip code inputs with stored value
     */
    function autopopulateZipCodeInputs() {
      const storedZip = zipCodeManager.get();
      if (!storedZip) return;

      const inputs = findZipCodeInputs();
      inputs.forEach((input) => {
        if (!input.value || input.value.length === 0) {
          input.value = storedZip;
          // Trigger change event for any listeners
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /**
     * Listen for zip code changes on PDP and save to storage
     */
    function monitorZipCodeInputs() {
      const inputs = findZipCodeInputs();

      inputs.forEach((input) => {
        // Debounce the save operation
        let saveTimer;

        const handleZipInput = (event) => {
          const value = event.target.value;

          // Clear existing timer
          if (saveTimer) {
            clearTimeout(saveTimer);
          }

          // Only save if it's a valid 5-digit zip
          if (zipCodeManager.validate(value)) {
            saveTimer = setTimeout(() => {
              zipCodeManager.set(value);
            }, 500); // 500ms debounce
          }
        };

        input.addEventListener('input', handleZipInput);
        input.addEventListener('change', handleZipInput);
        input.addEventListener('blur', handleZipInput);
      });
    }

    /**
     * Initialize on page load
     */
    function init() {
      // Auto-populate inputs with stored value
      autopopulateZipCodeInputs();

      // Monitor for changes
      monitorZipCodeInputs();

      // Re-check for new inputs after a delay (in case of dynamic loading)
      setTimeout(() => {
        autopopulateZipCodeInputs();
        monitorZipCodeInputs();
      }, 2000);
    }

    // Only run on product pages
    if (
      window.location.pathname.includes('/products/') ||
      document.querySelector('product-info') ||
      document.querySelector('[data-product-id]')
    ) {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    }
  }

  // Start initialization
  initPDPIntegration();
})();